import AjaxService from '../services/ajax-service';

export const fetchProjectTemplates = ({ category }) => {
    return AjaxService({
        method: 'get',
        url: `templates`,
        params: {
            category
        }
    }).then(response => response.data);
}

export const createProjectTemplate = ({ name, description, options, type, project_id }) => {
    return AjaxService({
        method: 'post',
        url: 'templates',
        data: {
            name,
            description: description || undefined,
            options,
            type,
            project_id
        }
    }).then(response => response.data.template);
}

export const removeProjectTemplate = projectTemplateId => {
    return AjaxService({
        method: 'delete',
        url: `templates/${projectTemplateId}`
    }).then(response => response.data);
}
